import { render, staticRenderFns } from "./OnBoardingConf.vue?vue&type=template&id=1156029f"
import script from "./OnBoardingConf.vue?vue&type=script&lang=js"
export * from "./OnBoardingConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports